import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Features from './components/Features';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import Comparison from './components/Comparison';
import Testimonials from './components/Testimonials';
import SEOArticles from './components/SEOArticles';
import Safety from './components/Safety';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.quest';

export default function Home() {
  return (
    <main className="w-full min-h-screen">
      <Navbar />
      <Hero />
      <Categories />
      <Features />
      <About />
      <HowItWorks />
      <Comparison />
      <SEOArticles />
      <Testimonials />
      <Safety />
      <FAQ />
      <CTA />
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "KakobuyFinds",
          "url": siteUrl,
          "description": "Największa baza wiedzy o Kakobuy Spreadsheet w Polsce",
          "inLanguage": "pl-PL"
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "KakobuyFinds",
          "url": siteUrl,
          "description": "Największa baza wiedzy o Kakobuy Spreadsheet w Polsce",
          "inLanguage": "pl-PL",
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${siteUrl}/?s={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "KakobuyFinds",
              "item": siteUrl
            }
          ]
        })}
      </script>
    </main>
  );
}